export default "__VITE_ASSET__CvbqSglN__"